import CustomTable from "components/common/table/CustomTable";
import { DEFAULT_PAGE_SIZE_OPTIONS } from "static/pagination";
import useNonEnrolledPatientsTable from "./hooks/useNonEnrolledPatientsTable";

const NonEnrolledPatientsTable = () => {
  const {
    data,
    isLoading,
    isFetching,
    isError,
    columns,
    pagination,
    setPagination,
    columnFilters,
    setColumnFilters,
    sorting,
    setSorting,
  } = useNonEnrolledPatientsTable();

  return (
    <CustomTable
      columns={columns}
      data={isError ? [] : data?.patients || []}
      options={{
        enableTopToolbar: false,
        enableSorting: true,
        enableRowSelection: false,
        rowCount: data?.meta?.total || 0,
        defaultColumn: {
          minSize: 20,
          maxSize: 9001,
          size: 150,
        },
        state: {
          isLoading: isLoading || isFetching,
          showGlobalFilter: false,
          showColumnFilters: true,
          pagination,
          columnFilters,
          sorting,
        },
        manualPagination: true,
        manualFiltering: true,
        manualSorting: true,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,
        rowsPerPageOptions: DEFAULT_PAGE_SIZE_OPTIONS,
      }}
    />
  );
};

export default NonEnrolledPatientsTable;
